const queryKey = (...args) => args;

export default {
  // account status (admin deactivation)
  accountStatus: (...args) => queryKey('accountStatus', ...args),
  accountStatusList: (search, offset) => queryKey('accountStatus', 'list', search, offset),

  // artists
  artists: (...args) => queryKey('artists', ...args),
  artist: (artistId) => queryKey('artists', artistId),
  adminArtists: (params) => queryKey('artists', 'admin', params),
  artistOnboardingLeader: (artistId) => queryKey('artists', artistId, 'onboarding-leader'),

  // artist audiences
  artistAudiences: (artistId) => queryKey('artists', artistId, 'campaigns', 'audiences'),

  // artist voices
  artistVoices: (artistId) => queryKey('artists', artistId, 'voices'),
  artistVoice: (artistId, voiceId) => queryKey('artists', artistId, 'voices', voiceId),

  // artist calendar
  artistCalendar: (artistId, ...args) => queryKey('artists', artistId, 'calendar', ...args),

  // artist pray tv schedule
  artistPrayTvSchedule: (artistId, ...args) => queryKey('artists', artistId, 'prayTvSchedule', ...args),
  artistPrayTvExpandedSlots: (artistId, ...args) => queryKey('artists', artistId, 'prayTvExpandedSlots', ...args),

  // artist pray radio schedule
  artistPrayRadioSchedule: (artistId, ...args) => queryKey('artists', artistId, 'prayRadioSchedule', ...args),
  artistPrayRadioDailyItems: (artistId, ...args) => queryKey('artists', artistId, 'prayRadioDailyItems', ...args),
  artistPrayRadioExpandedSlots: (artistId, ...args) => queryKey('artists', artistId, 'prayRadioExpandedSlots', ...args),

  // artist content details
  artistContentDetails: (artistId, contentId) => queryKey('artists', artistId, 'content', contentId, 'details'),
  artistContentDetailsLocale: (artistId, contentId, locale) =>
    queryKey('artists', artistId, 'content', contentId, 'details', 'locale', locale),
  artistContentTranslationAttempt: (artistId, contentId, locale) =>
    queryKey('artists', artistId, 'content', contentId, 'translationAttempt', 'locale', locale),
  artistContentDetailsLocaleTranscriptMultiVoices: (artistId, contentId, locale) =>
    queryKey('artists', artistId, 'content', contentId, 'details', 'locale', locale, 'transcripts', 'multiVoices'),

  // artist content series
  artistContentSeries: (artistId) => queryKey('artists', artistId, 'contentSeries'),
  artistContentSeriesById: (artistId, contentSeriesId) =>
    queryKey('artists', artistId, 'contentSeries', contentSeriesId),
  artistPrayRadioTvContentSeries: (artistId) => queryKey('artists', artistId, 'contentSeries', 'prayRadioTv'),
  // artist content categories
  artistContentCategories: (artistId) => queryKey('artists', artistId, 'contentCategories'),

  // artist content
  artistContent: (artistId, ...args) => queryKey('artists', artistId, 'content', ...args),

  // artist content social clips
  artistContentSocialClips: (artistId, contentId) => queryKey('artists', artistId, 'content', contentId, 'socialClips'),
  artistContentSocialClipById: (artistId, contentId, socialClipId) =>
    queryKey('artists', artistId, 'content', contentId, 'socialClips', socialClipId),

  // studio notifications
  studioNotifications: (artistId) => queryKey('artists', artistId, 'studioNotifications'),

  // artist conversations
  artistConversations: (artistId) => queryKey('artists', artistId, 'conversations'),
  artistConversation: (artistId, conversationId) => queryKey('artists', artistId, 'conversations', conversationId),

  // artist AI settings: transcription vocabulary and past-transcript jobs
  artistTranscriptionSettings: (artistId) => queryKey('artists', artistId, 'settings', 'transcription'),
  artistReplacementMatches: (artistId) => queryKey('artists', artistId, 'transcripts', 'replacement-matches'),
  artistApplyReplacementsJob: (artistId, jobId) =>
    queryKey('artists', artistId, 'transcripts', 'apply-replacements', jobId),

  // artist chatbot
  artistChatbot: (artistId) => queryKey('artists', artistId, 'chatbot'),
  // platform-wide chat base prompts (admin): chatbotPrompt(handler, type)
  chatbotPrompt: (...args) => queryKey('chatbot-prompt', ...args),
  artistChatbotConversations: (artistId, filters) =>
    queryKey('artists', artistId, 'chatbot', 'conversations', 'filters', filters),
  artistChatbotConversation: (artistId, userId) => queryKey('artists', artistId, 'chatbot', 'conversations', userId),
  artistConversationStats: (artistId, filters) =>
    queryKey('artists', artistId, 'chatbot', 'conversations', 'stats', 'filters', filters),
  artistConversationSearch: (artistId, params) => queryKey('artists', artistId, 'conversations', 'search', params),
  artistConversationAnalytics: (artistId, params) =>
    queryKey('artists', artistId, 'conversations', 'analytics', params),
  artistConversationInsights: (artistId, params) => queryKey('artists', artistId, 'conversations', 'insights', params),
  artistConversationJourney: (artistId, conversationId) =>
    queryKey('artists', artistId, 'conversations', conversationId, 'journey'),
  artistEmotionalFeed: (artistId, params) => queryKey('artists', artistId, 'conversations', 'emotional-feed', params),
  artistEmotionalJourney: (artistId, params) =>
    queryKey('artists', artistId, 'conversations', 'emotional-journey', params),

  // artist social posts
  artistSocialPosts: (artistId, ...args) => queryKey('artists', artistId, 'socialPosts', ...args),

  // artist daily serires
  artistDailySeries: (artistId, dailySeriesId) => queryKey('artists', artistId, 'dailySeries', dailySeriesId),
  artistDailySeriesCoverArts: (artistId, dailySeriesId) =>
    queryKey('artists', artistId, 'dailySeries', dailySeriesId, 'coverArts'),

  // artist announcements
  artistAnnouncements: (artistId) => queryKey('artists', artistId, 'announcements'),
  artistAnnouncement: (artistId, announcementId) => queryKey('artists', artistId, 'announcements', announcementId),
  artistAnnouncementWorkflowAI: (artistId, contentId, locale) =>
    queryKey('artists', artistId, 'content', contentId, 'locale', locale, 'announcement'),
  artistAnnouncementMetrics: (artistId, announcementId) =>
    queryKey('artists', artistId, 'announcements', announcementId, 'metrics'),

  // artist locales
  artistLocales: (artistId) => queryKey('artist', artistId, 'locales'),

  // artist funds
  artistFunds: (artistId, ...args) => queryKey('artist', artistId, 'funds', ...args),
  artistFund: (artistId, fundId) => queryKey('artist', artistId, 'funds', fundId),

  // artist giving payments
  artistGivingPayments: (artistId, ...args) => queryKey('artists', artistId, 'givingPayments', ...args),
  artistGivingStatementYearlyCounts: (artistId) =>
    queryKey('artists', artistId, 'givingPayments', 'statementYearlyCounts'),

  // artist giving summary
  artistGivingSummary: (artistId, ...args) => queryKey('artists', artistId, 'givingSummary', ...args),

  // artist donations
  artistDonationFund: (artistId) => queryKey('artist', artistId, 'donationFund'),
  artistDonationPayouts: (artistId, ...args) => queryKey('artists', artistId, 'payouts', ...args),
  artistPayoutsSummary: (artistId) => queryKey('artists', artistId, 'payouts', 'summary'),
  artistTransactionsSummary: (artistId) => queryKey('artists', artistId, 'transactions', 'summary'),
  artistPayoutById: (artistId, payoutId, ...args) => queryKey('artists', artistId, 'payouts', payoutId, ...args),
  artistPayoutTransactions: (artistId, payoutId, ...args) =>
    queryKey('artists', artistId, 'payouts', payoutId, 'transactions', ...args),

  // artist warmup campaigns
  artistWarmupCampaigns: (artistId, ...args) => queryKey('artists', artistId, 'warmupCampaigns', ...args),
  artistWarmupCampaign: (artistId, warmupId) => queryKey('artists', artistId, 'warmupCampaigns', warmupId),
  artistWarmupAudienceOptions: (artistId) => queryKey('artists', artistId, 'warmupCampaigns', 'audienceOptions'),
  artistWarmupSendingOptions: (artistId) => queryKey('artists', artistId, 'warmupCampaigns', 'sendingOptions'),

  // artist recurring campaigns
  artistRecurringCampaigns: (artistId, ...args) => queryKey('artists', artistId, 'recurringCampaigns', ...args),
  artistRecurringCampaign: (artistId, id) => queryKey('artists', artistId, 'recurringCampaigns', id),
  artistRecurringInstances: (artistId, id, ...args) =>
    queryKey('artists', artistId, 'recurringCampaigns', id, 'instances', ...args),
  artistRecurringAudienceOptions: (artistId) => queryKey('artists', artistId, 'recurringCampaigns', 'audienceOptions'),

  // artist recurring push campaigns
  artistRecurringPushCampaigns: (artistId, ...args) => queryKey('artists', artistId, 'recurringPushCampaigns', ...args),
  artistRecurringPushCampaign: (artistId, id) => queryKey('artists', artistId, 'recurringPushCampaigns', id),
  artistRecurringPushInstances: (artistId, id, ...args) =>
    queryKey('artists', artistId, 'recurringPushCampaigns', id, 'instances', ...args),
  artistRecurringPushAudienceOptions: (artistId) =>
    queryKey('artists', artistId, 'recurringPushCampaigns', 'audienceOptions'),

  // artist email campaigns
  artistEmailCampaigns: (artistId, ...args) => queryKey('artists', artistId, 'emailCampaigns', ...args),
  artistEmailCampaign: (artistId, campaignId) => queryKey('artists', artistId, 'emailCampaigns', campaignId),

  // artist push campaigns
  artistPushCampaigns: (artistId, ...args) => queryKey('artists', artistId, 'pushCampaigns', ...args),
  artistPushCampaign: (artistId, campaignId) => queryKey('artists', artistId, 'pushCampaigns', campaignId),
  artistEmailCampaignStatus: (artistId, audienceType, audienceIds) =>
    queryKey(
      'artists',
      artistId,
      'emailCampaigns',
      'status',
      audienceType,
      audienceIds ? JSON.stringify(audienceIds) : 'none'
    ),
  artistEmailCampaignFromWorkflowAI: (artistId, contentId, locale) =>
    queryKey('artists', artistId, 'content', contentId, 'locale', locale, 'email'),
  artistLeadsLists: (artistId) => queryKey('artists', artistId, 'leadsLists'),

  // artist emails
  artistEmails: (artistId) => queryKey('artists', artistId, 'emails'),

  // artist email senders
  artistEmailSenders: (artistId) => queryKey('artists', artistId, 'emailSenders'),

  // artist unsubscribe groups
  artistUnsubscribeGroups: (artistId) => queryKey('artists', artistId, 'unsubscribeGroups'),

  // artist sendgrid ip pools
  artistIpPools: (artistId) => queryKey('artists', artistId, 'ipPools'),
  artistAvailableIps: (artistId) => queryKey('artists', artistId, 'availableIps'),

  // artist email templates
  artistEmailTemplates: (artistId, ...args) => queryKey('artists', artistId, 'emailTemplates', ...args),
  artistEmailTemplate: (artistId, templateId) => queryKey('artists', artistId, 'emailTemplates', templateId),
  emailTemplatesPreview: (artistId) => queryKey('artists', artistId, 'emailTemplatesPreview'),

  // artist followers
  artistFollowers: (artistId, ...args) => queryKey('artists', artistId, 'followers', ...args),
  artistFollowersMetadata: (artistId) => queryKey('artists', artistId, 'followers', 'metadata'),

  // artist testimonials
  artistTestimonials: (artistId, ...args) => queryKey('artists', artistId, 'testimonials', ...args),

  // artist periodic table
  artistPeriodicTable: (artistId) => queryKey('artists', artistId, 'periodicTable'),
  artistPeriodicTableSegments: (artistId, ...args) =>
    queryKey('artists', artistId, 'periodicTable', 'segments', ...args),

  // artist summary
  artistSummary: (artistId) => queryKey('artists', artistId, 'summary'),
  artistInstagramSummary: (artistId) => queryKey('artists', artistId, 'social', 'instagram'),
  artistYoutubeSummary: (artistId) => queryKey('artists', artistId, 'social', 'youtube'),
  artistYouTubeConnectionStatus: (artistId) => queryKey('artists', artistId, 'socials', 'youtube', 'connectionStatus'),

  // artist impact metrics
  artistImpactMetrics: (artistId) => queryKey('artists', artistId, 'impactMetrics'),

  // cover art
  artistCoverArts: (artistId) => queryKey('artists', artistId, 'coverArts'),

  // locales
  locales: () => queryKey('locales'),

  // artist offers
  artistOffers: (artistId, ...args) => queryKey('artists', artistId, 'offers', ...args),
  artistOffer: (artistId, offerId) => queryKey('artists', artistId, 'offers', offerId),
  // SUPPORT-1634 offer funnel
  offerFunnelOffers: (artistId) => queryKey('artists', artistId, 'offer-funnel', 'offers'),
  offerFunnelUsages: (artistId, offerId) => queryKey('artists', artistId, 'offer-funnel', 'offers', offerId, 'usages'),
  offerFunnelEditions: (artistId, offerId) =>
    queryKey('artists', artistId, 'offer-funnel', 'offers', offerId, 'editions'),
  offerFunnelCampaign: (artistId, campaignId) => queryKey('artists', artistId, 'offer-funnel', 'campaigns', campaignId),
  offerFunnelAutomationChecks: (artistId, automationId) =>
    queryKey('artists', artistId, 'offer-funnel', 'automations', automationId, 'checks'),

  // funds
  fund: (fundId, options = {}) => queryKey('funds', fundId, options),

  // lead campaigns
  leadCampaigns: (...args) => queryKey('leadCampaigns', ...args),
  leadCampaign: (campaignId) => queryKey('leadCampaigns', campaignId),

  // lead clients
  leadClients: (...args) => queryKey('leadClients', ...args),
  leadClient: (clientId) => queryKey('leadClients', clientId),
  leadClientIntegrations: (artistId) => queryKey('leadClientIntegrations', artistId),

  // ministries
  ministryMatch: (userId, latitude, longitude) =>
    queryKey('ministryMatch', 'userId', userId, 'latitude', latitude, 'longitude', longitude),

  // transcripts
  transcripts: (artistId, contentId, locale) =>
    queryKey('artists', artistId, 'content', contentId, 'locales', locale, 'transcripts'),

  artistConnectedSocialPlatforms: (artistId) => queryKey('artist', artistId, 'socials', 'connected-platforms'),
  artistConnectAccountUrl: (artistId) => queryKey('artist', artistId, 'socials', 'connect-account-url'),
  // onboarding
  onboardingSteps: () => queryKey('onboarding'),
  // newsletter
  newsletterSteps: (handle) => queryKey('newsletter', handle),
  // email onboarding
  emailOnboardingSteps: () => queryKey('email-onboarding'),
  // leader offer / campaign by leader
  leaderOffer: (artistId) => queryKey(artistId, 'leader-offer'),
  // full list of a leader's lead campaigns (SuperFunnel + web)
  leaderLeadCampaigns: (artistId) => queryKey(artistId, 'leader-lead-campaigns'),
  // leader fund by leader
  leaderFund: (artistId) => queryKey(artistId, 'leader-fund'),

  // email contact list
  leadsLists: (artistId, filters) => queryKey('artists', artistId, 'leadsLists', 'filters', filters),
  leadsListId: (artistId, listId, filters) => queryKey('artists', artistId, 'leadsList', listId, 'filters', filters),
  leadsListIdMappings: (artistId, listId) => queryKey('artists', artistId, 'leadsLists', listId, 'mappings'),
  leadsListMetadata: (artistId, listId) => queryKey('artists', artistId, 'leadsList', listId, 'metadata'),
  leadsListMappings: (artistId, headers) => queryKey('leadsLists', 'mappings', artistId, ...headers),
  createLeadsList: (artistId) => queryKey('artist', artistId, 'leadsLists'),
  retryUploadLeadsList: (artistId, listId) => queryKey('artist', artistId, 'leadsList', listId, 'upload'),

  // catalogs
  catalogs: (artistId, filters) => queryKey('artists', artistId, 'catalogs', 'filters', filters),
  catalog: (artistId, catalogId) => queryKey('artists', artistId, 'catalog', catalogId),
  catalogItems: (artistId, catalogId, filters) =>
    queryKey('artists', artistId, 'catalog', catalogId, 'items', 'filters', filters),
  catalogImport: (artistId, catalogId, importId) =>
    queryKey('artists', artistId, 'catalog', catalogId, 'import', importId),
  catalogProbe: (artistId, catalogId) => queryKey('artists', artistId, 'catalog', catalogId, 'probe'),

  // lead segments
  leadSegment: (artistId, segmentId) => queryKey('artists', artistId, 'leadSegments', segmentId),
  leadSegments: (artistId, filters) => queryKey('artists', artistId, 'leadSegments', 'filters', filters),
  leadSegmentOptions: () => queryKey('leadSegmentOptions'),

  // profile segments: server_pray's segmentation module, platform-wide, not per artist
  profileSegmentFields: () => queryKey('profileSegmentFields'),
  profileSegments: (filters) => queryKey('profileSegments', 'filters', filters),
  profileSegment: (segmentId) => queryKey('profileSegments', segmentId),
  profileSegmentCount: (segmentId) => queryKey('profileSegmentCount', segmentId),
  profileSegmentPreview: (previewId) => queryKey('profileSegmentPreview', previewId),
  profileSegmentRefresh: () => queryKey('profileSegmentRefresh'),

  // Add this if not already present
  artistContentArticle: (artistId, contentId, locale) =>
    queryKey('artists', artistId, 'content', contentId, 'locale', locale, 'article'),

  artistContentStudyGuide: (artistId, contentId, locale) =>
    queryKey('artists', artistId, 'content', contentId, 'locale', locale, 'study-guide'),

  // artist articles
  artistArticles: (artistId) => queryKey('artists', artistId, 'articles'),
  artistArticle: (artistId, articleId) => queryKey('artists', artistId, 'articles', articleId),
  articlePreviewLink: (artistId, articleId) => queryKey('article-preview-links', artistId, articleId),

  // artist pages (page builder)
  artistPages: (artistId) => queryKey('artists', artistId, 'pages'),
  artistPage: (artistId, pageId) => queryKey('artists', artistId, 'pages', pageId),

  // artist articles builder (GrapeJS)
  artistBuilderArticles: (artistId) => queryKey('artists', artistId, 'builder-articles'),
  artistBuilderArticle: (artistId, articleId) => queryKey('artists', artistId, 'builder-articles', articleId),

  // artist books
  artistBooks: (artistId) => queryKey('artists', artistId, 'books'),
  artistBooksSearch: (artistId, searchQuery) => queryKey('artists', artistId, 'books', 'search', searchQuery),
  artistBookDetails: (artistId, bookId) => queryKey('artists', artistId, 'books', bookId),
  artistBookStatus: (artistId, bookId) => queryKey('artists', artistId, 'books', bookId, 'status'),
  artistBookChapters: (artistId, bookId) => queryKey('artists', artistId, 'books', bookId, 'chapters'),
  artistBookChapter: (artistId, bookId, chapterId) =>
    queryKey('artists', artistId, 'books', bookId, 'chapters', chapterId),
  artistBookChapterDraft: (artistId, bookId, chapterId) =>
    queryKey('artists', artistId, 'books', bookId, 'chapters', chapterId, 'draft'),
  artistBookChapterVersions: (artistId, bookId, chapterId) =>
    queryKey('artists', artistId, 'books', bookId, 'chapters', 'versions', chapterId),
  artistBookAllChaptersVersions: (artistId, bookId) =>
    queryKey('artists', artistId, 'books', bookId, 'chapters', 'versions'),

  // artist account
  artistAccountOverview: (artistId) => queryKey('artists', artistId, 'account', 'overview'),

  // artist credits
  artistCreditAccount: (artistId) => queryKey('artists', artistId, 'credits', 'account'),
  creditPlans: () => queryKey('credits', 'plans'),
  creditAccounts: (searchQuery) => queryKey('credits', 'accounts', searchQuery),

  // courses
  artistCourses: (artistId) => queryKey('artists', artistId, 'courses'),
  artistCourse: (artistId, courseId) => queryKey('artists', artistId, 'courses', courseId),
  artistCourseEpisodes: (artistId, courseId) => queryKey('artists', artistId, 'courses', courseId, 'episodes'),
  artistCourseEpisode: (artistId, courseId, episodeId) =>
    queryKey('artists', artistId, 'courses', courseId, 'episodes', episodeId),

  // experiments
  experiments: (...args) => queryKey('experiments', ...args),
  experimentDetails: (experimentId, instanceName) => queryKey('experiments', experimentId, instanceName),
  experimentInstances: () => queryKey('experiment-instances'),
  experimentsInstanceCounts: () => queryKey('experiments', 'instance-counts'),
  experimentImages: (instanceId) => queryKey('experiment-images', instanceId),
  experimentCategories: (filters) => queryKey('experiment-categories', filters),
  experimentsByCategory: (filters) => queryKey('experiments', 'by-category', filters),
  instanceGroups: (params) => queryKey('experiment-instance-groups', params),
  instanceExperiments: (params) => queryKey('experiments', 'by-instance', params),
  experimentFunnelAnalytics: (experimentId, instanceName, startDate, endDate) =>
    queryKey('experiments', experimentId, 'analytics', 'funnel', instanceName, startDate, endDate),
  experimentConfigurableFunnel: (experimentId, instanceName, experimentListNumber, startDate, endDate, funnelSteps) =>
    queryKey(
      'experiments',
      experimentId,
      'analytics',
      'funnel',
      'configurable',
      instanceName,
      experimentListNumber,
      startDate,
      endDate,
      funnelSteps
    ),
  experimentIndividualMetrics: (experimentId, instanceName, experimentListNumber, startDate, endDate, metrics) =>
    queryKey(
      'experiments',
      experimentId,
      'analytics',
      'metrics',
      instanceName,
      experimentListNumber,
      startDate,
      endDate,
      metrics
    ),
  experimentRetention: (
    experimentId,
    instanceName,
    experimentListNumber,
    startDate,
    endDate,
    fromCohort,
    toActivity,
    maxDays
  ) =>
    queryKey(
      'experiments',
      experimentId,
      'analytics',
      'retention',
      instanceName,
      experimentListNumber,
      startDate,
      endDate,
      fromCohort,
      toActivity,
      maxDays
    ),
  experimentUsers: (experimentId, instanceName, experimentListNumber, variation, page, pageSize) =>
    queryKey(
      'experiments',
      experimentId,
      'analytics',
      'users',
      instanceName,
      experimentListNumber,
      variation,
      page,
      pageSize
    ),

  // email automations
  emailAutomations: (artistId, filters) => queryKey('artists', artistId, 'emailAutomations', 'filters', filters),

  // translation queue stats
  translationQueueStats: (artistId) => queryKey('queues', 'translation', 'stats', artistId),

  // translation tasks
  translationTasks: (params) => queryKey('queues', 'translation', 'tasks', params),

  // artist queue slots
  artistQueueSlots: (artistId) => queryKey('artists', artistId, 'queues', 'slots'),

  // feature flags
  featureFlags: () => queryKey('featureFlags'),
  featureFlagEvaluate: (platform, appType, artistId) =>
    queryKey('featureFlags', 'evaluate', platform, appType, artistId),

  // web toggles
  webToggles: () => queryKey('web', 'toggles'),

  // home feed — one query per row, keyed so a row can be invalidated on its own
  homeFeedRow: (rowId, ...args) => queryKey('home', 'rows', rowId, ...args),

  // studio disputes
  studioDisputes: (filters) => queryKey('studio', 'disputes', 'filters', filters),
  studioDisputeById: (disputeId) => queryKey('studio', 'disputes', disputeId),
  studioDisputeSettings: () => queryKey('studio', 'disputes', 'settings'),
  studioDisputeAlertRecipients: () => queryKey('studio', 'disputes', 'alert-recipients'),
  studioDisputeMetrics: (filters) => queryKey('studio', 'disputes', 'metrics', filters),

  // brand kit
  brandKit: (artistId) => queryKey('artists', artistId, 'brandKit'),
  adminBrandKits: () => queryKey('admin', 'brandKits'),

  // workflow AI settings
  workflowAISettings: (artistId) => queryKey('artists', artistId, 'workflowAI', 'settings'),

  // workflow automations
  superFunnelMigrationAutomations: () => queryKey('admin', 'superFunnelMigrationAutomations'),
  weeklyReportUnsubscribe: (token) => queryKey('superfunnel-weekly-report', 'unsubscribe', token),
  // Every weekly report key starts here, so one invalidation refreshes the whole admin page.
  weeklyReportAll: () => queryKey('superfunnel-weekly-report'),
  weeklyReportSettings: () => queryKey('superfunnel-weekly-report', 'settings'),
  weeklyReportUnsubscribes: (...args) => queryKey('superfunnel-weekly-report', 'unsubscribes', ...args),
  weeklyReportSummary: () => queryKey('superfunnel-weekly-report', 'summary'),
  weeklyReportPerformance: () => queryKey('superfunnel-weekly-report', 'performance'),
  weeklyReportPreview: (artistId) => queryKey('superfunnel-weekly-report', 'preview', artistId),
  weeklyReportScopeSearch: (scopeType, search) =>
    queryKey('superfunnel-weekly-report', 'scope-search', scopeType, search),
  workflowAutomations: (artistId, ...args) => queryKey('artists', artistId, 'workflowAutomations', ...args),
  workflowAutomation: (artistId, workflowId) => queryKey('artists', artistId, 'workflowAutomations', workflowId),
  workflowMetrics: (artistId, workflowId, versionNumber) =>
    queryKey('artists', artistId, 'workflowAutomations', workflowId, 'versions', versionNumber, 'metrics'),
  workflowVersions: (artistId, workflowId) =>
    queryKey('artists', artistId, 'workflowAutomations', workflowId, 'versions'),
  workflowDraftVersion: (artistId, workflowId) =>
    queryKey('artists', artistId, 'workflowAutomations', workflowId, 'versions', 'draft'),
  workflowVersionNumber: (artistId, workflowId, versionNumber) =>
    queryKey('artists', artistId, 'workflowAutomations', workflowId, 'versions', versionNumber),
  workflowTemplates: (artistId, filters) => queryKey('artists', artistId, 'workflowTemplates', 'filters', filters),
  artistWorkflowLists: (artistId) => queryKey('artists', artistId, 'workflowLists'),

  // content analytics
  artistListenAnalytics: (artistId, startDate, endDate, seriesTitle = null) =>
    queryKey('artists', artistId, 'analytics', 'listen', startDate, endDate, seriesTitle),
  artistWatchAnalytics: (artistId, startDate, endDate, seriesTitle = null) =>
    queryKey('artists', artistId, 'analytics', 'watch', startDate, endDate, seriesTitle),
  artistAudienceAnalytics: (artistId, startDate, endDate) =>
    queryKey('artists', artistId, 'analytics', 'audience', startDate, endDate),
  artistListenTopContent: (artistId, startDate, endDate) =>
    queryKey('artists', artistId, 'analytics', 'listen', 'top-content', startDate, endDate),
  artistWatchTopContent: (artistId, startDate, endDate) =>
    queryKey('artists', artistId, 'analytics', 'watch', 'top-content', startDate, endDate),

  // reports
  artistReports: (artistId) => queryKey('artists', artistId, 'reports'),
  artistReport: (artistId, reportId) => queryKey('artists', artistId, 'reports', reportId),
  artistReportSlide: (artistId, reportId, slideId) =>
    queryKey('artists', artistId, 'reports', reportId, 'slides', slideId),

  // members
  membersSearch: (params) => queryKey('members', 'search', params),
  memberDetails: (memberId) => queryKey('members', memberId),
  memberStreaks: (memberId) => queryKey('members', memberId, 'streaks'),
  memberStreakSessionsBase: (memberId) => queryKey('members', memberId, 'streaks', 'sessions'),
  memberStreakSessions: (memberId, month) => queryKey('members', memberId, 'streaks', 'sessions', month),
  memberCampaigns: (memberId, params) => queryKey('members', memberId, 'campaigns', params),
  memberNotifications: (memberId) => queryKey('members', memberId, 'notifications'),
  memberContentViews: (memberId, params) => queryKey('members', memberId, 'content-views', params),
  // *Base keys carry no params slot: a key ending in `undefined` never partial-matches one ending in
  // `{ limit }`, so invalidations must use the base form.
  memberPurchasesBase: (memberId) => queryKey('members', memberId, 'purchases'),
  memberPurchases: (memberId, params) => queryKey('members', memberId, 'purchases', params),
  memberTransactionsBase: (memberId) => queryKey('members', memberId, 'transactions'),
  memberTransactions: (memberId, params) => queryKey('members', memberId, 'transactions', params),
  memberSubscriptionsBase: (memberId) => queryKey('members', memberId, 'subscriptions'),
  memberSubscriptions: (memberId, params) => queryKey('members', memberId, 'subscriptions', params),
  memberOrganizations: (memberId) => queryKey('members', memberId, 'organizations'),

  // organizations
  organizationsSearch: (params) => queryKey('organizations', 'search', params),
  organizationDetail: (organizationId) => queryKey('organizations', organizationId),
  organizationMembers: (organizationId, params) => queryKey('organizations', organizationId, 'members', params),
  organizationServices: (organizationId) => queryKey('organizations', organizationId, 'services'),
  organizationFunds: (organizationId) => queryKey('organizations', organizationId, 'funds'),
  organizationDailySeries: (organizationId) => queryKey('organizations', organizationId, 'daily-series'),
  organizationGivingAccount: (organizationId) => queryKey('organizations', organizationId, 'giving-account'),

  // content series (studio admin, cross-leader list)
  adminContentSeries: (params) => queryKey('content-series', 'admin', params),

  // products (studio admin)
  productsAdmin: (params) => queryKey('products', 'admin', params),
  productAdmin: (productId) => queryKey('products', 'admin', 'detail', productId),

  // purchases (studio admin)
  purchasesAdmin: (params) => queryKey('purchases', 'admin', params),

  // products subscriptions (studio admin)
  productsSubscriptionsAdmin: (params) => queryKey('products-subscriptions', 'admin', params),

  // giving accounts (studio admin)
  givingAccountsAdmin: (params) => queryKey('giving-accounts', 'admin', params),

  // content categories (studio admin)
  contentCategoriesAdmin: (params) => queryKey('content-categories', 'admin', params),

  // abn testing (studio admin, chameleon instances)
  abnTestingInstances: () => queryKey('abn-testing', 'instances'),
  abnTestingInstanceExperiments: (instanceName, type) =>
    queryKey('abn-testing', 'instances', instanceName, 'experiments', type),
  abnTestingVariation: (instanceName, experimentId, variationId) =>
    queryKey('abn-testing', 'instances', instanceName, 'experiments', experimentId, 'variations', variationId),
  abnTestingVariationTranslations: (instanceName, experimentId, variationId, locale) =>
    queryKey(
      'abn-testing',
      'instances',
      instanceName,
      'experiments',
      experimentId,
      'variations',
      variationId,
      'translations',
      locale ?? null
    ),
  abnTestingTranslatedVariation: (instanceName, experimentId, variationId, locale) =>
    queryKey(
      'abn-testing',
      'instances',
      instanceName,
      'experiments',
      experimentId,
      'variations',
      variationId,
      'translated',
      locale
    ),

  // system check
  systemCheckTranslations: (mediaType) => queryKey('system-check', 'translations', mediaType),
  systemCheckWorkflow: (artistId) => queryKey('system-check', 'workflow', artistId),
  systemCheckSocialClips: (status) => queryKey('system-check', 'social-clips', status),
  systemCheckSocialPosts: () => queryKey('system-check', 'social-posts'),
  systemCheckDailies: () => queryKey('system-check', 'dailies'),
  systemCheckSfSubscriptions: (scope, campaignId, cohortFrom, cohortTo) =>
    queryKey('system-check', 'sf-subscriptions', scope, campaignId ?? null, cohortFrom ?? null, cohortTo ?? null),
  systemCheckSfImpressions: (from, to, leaderId, limit) =>
    queryKey('system-check', 'sf-impressions', from ?? null, to ?? null, leaderId ?? null, limit ?? null),
  systemCheckLeadValidation: () => queryKey('system-check', 'lead-validation'),
  systemCheckLeadPipeline: (rangeDays) => queryKey('system-check', 'lead-pipeline', rangeDays),

  // email health
  systemCheckEmailHealthOverview: (startDate, endDate) =>
    queryKey('system-check', 'email-health', 'overview', startDate, endDate),
  systemCheckEmailHealthDomains: () => queryKey('system-check', 'email-health', 'domains'),
  systemCheckEmailHealthSuppressions: (type) => queryKey('system-check', 'email-health', 'suppressions', type),
  systemCheckEmailHealthActivity: (startDate, endDate) =>
    queryKey('system-check', 'email-health', 'activity', startDate, endDate),
  systemCheckEmailHealthGmail: (domain, startDate, endDate) =>
    queryKey('system-check', 'email-health', 'gmail', domain, startDate, endDate),
  systemCheckEmailHealthReputation: (startDate, endDate) =>
    queryKey('system-check', 'email-health', 'reputation', startDate, endDate),

  // artist SMS config
  artistSmsConfig: (artistId) => queryKey('artists', artistId, 'smsConfig'),
  artistSmsAnalytics: (artistId, params) => queryKey('artists', artistId, 'smsAnalytics', params),
  artistSmsLogs: (artistId, params) => queryKey('artists', artistId, 'smsLogs', params),

  // comments
  contentWithComments: (artistId) => queryKey('contentWithComments', artistId),
  contentComments: (entityId, entityType) => queryKey('contentComments', entityId, entityType),
  commentReplies: (commentId) => queryKey('commentReplies', commentId),

  // seed emails (Studio admin tools > Seed Emails)
  seedEmailsSeeds: (filters) => queryKey('seed-emails', 'seeds', filters),
  seedEmailsGroups: (filters) => queryKey('seed-emails', 'groups', filters),
  seedEmailsGroup: (groupId) => queryKey('seed-emails', 'groups', groupId),
  seedEmailsSettings: () => queryKey('seed-emails', 'settings'),
  seedEmailsProviderSeedlist: () => queryKey('seed-emails', 'provider-seedlist'),
  // No argument: the registry is a static table in the server and the route takes nothing.
  seedEmailsTemplates: () => queryKey('seed-emails', 'templates'),
  seedEmailsCampaign: (artistId, campaignType, campaignId) =>
    queryKey('seed-emails', 'campaign', artistId, campaignType, campaignId),
  seedEmailsPreview: (input) => queryKey('seed-emails', 'preview', input),
  seedEmailsRuns: (filters) => queryKey('seed-emails', 'runs', filters),
  // A created run is written into this key so the Done page reads it without a second round trip,
  // and `GET /runs/:run_id` fills the same key when the detail page opens.
  seedEmailsRun: (runId) => queryKey('seed-emails', 'run', runId),
  seedEmailsRunRecipients: (runId, params) => queryKey('seed-emails', 'run', runId, 'recipients', params),

  // CRM analytics
  crmAnalyticsCampaignsByStatus: (...args) => queryKey('crm-analytics', 'campaigns-by-status', ...args),
  crmAnalyticsCampaignsByMetrics: (...args) => queryKey('crm-analytics', 'campaigns-by-metrics', ...args),
  crmAnalyticsSendsByArtist: (...args) => queryKey('crm-analytics', 'sends-by-artist', ...args),
  crmAnalyticsCampaigns: (...args) => queryKey('crm-analytics', 'campaigns', ...args),
  crmAnalyticsAutomationsByStatus: (...args) => queryKey('crm-analytics', 'automations-by-status', ...args),
  crmAnalyticsAutomationsByArtist: (...args) => queryKey('crm-analytics', 'automations-by-artist', ...args),
  crmAnalyticsTriggerDistribution: (...args) => queryKey('crm-analytics', 'trigger-distribution', ...args),
  crmAnalyticsExecutionFunnel: (...args) => queryKey('crm-analytics', 'execution-funnel', ...args),
  crmAnalyticsAutomations: (...args) => queryKey('crm-analytics', 'automations', ...args),
  crmAnalyticsDomainPerformance: (...args) => queryKey('crm-analytics', 'domain-performance', ...args),
  nameCaptureLeadCompleteness: (...args) => queryKey('name-capture', 'lead-completeness', ...args),
  nameCaptureCampaignBreakdown: (...args) => queryKey('name-capture', 'campaign-breakdown', ...args),
  nameCaptureDeliveryHealth: (...args) => queryKey('name-capture', 'delivery-health', ...args),
  nameCaptureLeadUserComparison: (...args) => queryKey('name-capture', 'lead-user-comparison', ...args),

  // Studio admin translations and legacy settings
  tagLocales: (tagId) => queryKey('tags', tagId, 'locales'),
  dailyItemLocales: (artistId, dailySeriesId, dailyItemId) =>
    queryKey('artists', artistId, 'daily-series', dailySeriesId, 'daily-items', dailyItemId, 'locales'),
  organizationDolly: (organizationId) => queryKey('organizations', organizationId, 'dolly'),
};
